import http from 'plugins/axios';

export default {
    userRiskFlagList(data) {
        return http.post({
        //   url: '/admin/riskQuery/userRiskFlagList',
            url:'/admin/riskQuery/userRiskInfoByIds',
          data
        });
      },
    getAllCoins() {
        return http.get({
            url: '/admin/tx/internal/conf'
        });
    },
    getWithdrawInternalList(data) {
        return http.get({
            url: '/admin/tx/internal/list',
            data: data
        });
    },
    transfer(data) {
        return http.post({
            url: '/admin/tx/internal/audit',
            data: data,
            dataType: 'form'
        });
    },
    findUserWithdrawalAndDepositRecord(data) {
        return http.get({
            url: '/admin/tx/internal/findByUse/record',
            data: data
        });
    },
    getRebateAmount(data) {
        return http.get({
          url: '/admin/workorder/findByUse/inviteRewards',
          data
        });
    },
};
